import { useState } from "react";
import { BASE_URL } from '../constants'
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Loader } from "lucide-react"
import '@fortawesome/fontawesome-svg-core/styles.css'

function LoginPage() {
  var history = useHistory()
  var location = useLocation()
  var { from } = location.state || { from: { pathname: '/' } }
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [stepTwoCode, setStepTwoCode] = useState('')
  const [isStepTwo, setIsStepTwo] = useState(false)
  const [provider, setProvider] = useState('')
  const [stepTwoToken, setStepTwoToken] = useState('')
  const [stepOneError, setStepOneError] = useState('')
  const [stepTwoError, setStepTwoError] = useState('')
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      var result = await fetch(`${BASE_URL}api/Auth/login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username,
            password,
          })
        })
      if (result.status === 200) {
        setStepOneError('')
        const { name, token } = await result.json()
        localStorage.setItem('mapyourmove_name', name)
        localStorage.setItem('mapyourmove_token', token)
        history.replace(from)
      }
      else if (result.status === 202) {
        setStepOneError('')
        setIsStepTwo(true)
        const jsonresult = await result.json()
        setProvider(jsonresult.provider)
        setStepTwoToken(jsonresult.token)
      }
      else {
        const { message } = await result.json()
        setStepOneError(message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleStepTwoSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      var result = await fetch(`${BASE_URL}api/Auth/steptwo`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: stepTwoToken,
            code: stepTwoCode,
            provider: provider
          })
        })
      if (result.status === 200) {
        setStepTwoError('')
        const { name, token } = await result.json()
        localStorage.setItem('mapyourmove_name', name)
        localStorage.setItem('mapyourmove_token', token)
        history.replace(from)
      }
      else {
        const { message } = await result.json()
        setStepTwoError(message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="header">
        <div>
          <a className="logo" href="https://www.horrycountysc.gov">
            <img alt="Horry County Government logo" id="hcglogo" src="https://www.horrycountysc.gov/documents/icon" />
          </a>
          <h1>
            <span> GIS -</span>
            <strong>Login</strong>
          </h1>
        </div>
        <div className="decoration"></div>
      </div>

      <div className="sign-in-container">
        {isStepTwo ? (
          <form onSubmit={handleStepTwoSubmit}>
            <h2>Two-Factor Authentication</h2>
            <input type="text" placeholder="Two Factor Code" value={stepTwoCode} onChange={e => setStepTwoCode(e.target.value)} />
            <button type="submit" disabled={isLoading}>{isLoading && <Loader className="fa-spin" />} Sign In</button>
            {stepTwoError ? <p className="error">{stepTwoError}</p> : ''}
            <hr />
            <div className="text-muted">Requires a <a href="https://www.horrycountysc.gov/register">www.horrycountysc.gov</a> account for authorized access.</div>
          </form>
        ) : (
          <form onSubmit={handleLoginSubmit}>
            <h2>Map Your Move</h2>
            <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
            <button type="submit" disabled={isLoading}>{isLoading && <Loader className="fa-spin" />}Sign In</button>
            {stepOneError ? <p className="error">{stepOneError}</p> : ''}
            <hr />
            <div className="text-muted">Requires a <a href="https://www.horrycountysc.gov/register">www.horrycountysc.gov</a> account for authorized access.</div>
            <hr />
            <div style={{
              padding: '1rem',
              background: '#f2f2f2',
              flexDirection: 'column',
              gap: '.5rem'
            }}>
              <div>Having trouble?</div>
              <div className="text-muted" style={{ gap: '.35rem' }}>
                <strong><a href="https://www.horrycountysc.gov/register" target="_blank">
                  Register
                </a></strong>
                to create an account
              </div>
              <div className="text-muted" style={{ gap: '.35rem' }}>Recover my
                <strong><a href="https://www.horrycountysc.gov/username-recovery" target="_blank">Username</a></strong>
                |
                <strong><a href="https://www.horrycountysc.gov/password-recovery" target="_blank">Password</a></strong>
              </div>
            </div>
          </form>
        )}
      </div>
      <img className="background-img" src="images/login-background.jpg" alt="" />

      <div className="footer">
        <div className="decoration"></div>
      </div>
    </>
  );
}

export default LoginPage;
